import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';

import CompactLayout from 'src/layouts/compact';

import { SplashScreen } from 'src/components/loading-screen';
import AppAuthGuard from 'src/components/auth/app-auth-guard';

import { rootRoute } from './root';

const GuidePage = lazy(() => import('src/sections/guide/guide'));

export const guideRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'guide',
  component: () => (
    <AppAuthGuard splashScreen={<SplashScreen />}>
      <CompactLayout>
        <GuidePage />
      </CompactLayout>
    </AppAuthGuard>
  ),
});
